"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteAttributeDialog = void 0;
var delete_attribute_dialog_component_1 = require("./delete-attribute-dialog.component");
Object.defineProperty(exports, "DeleteAttributeDialog", { enumerable: true, get: function () { return delete_attribute_dialog_component_1.DeleteAttributeDialog; } });
